export default __webpack_public_path__ + "static/sportive-645a29b7fdf4ce9fcb4b22d3a5e113fb.png";